import * as React from "react";
import "./Home.css";
import { ClassNames } from "../../_helpers/ClassNames";
import HomeItem from "./HomeItem";

export type HomeProps = HomeDto;

export class Home extends React.Component<HomeProps> {
  constructor(props: HomeProps) {
    super(props);
  }

  render() {
    const { Projects, OneColumn } = this.props;

    return (
      <div className={ClassNames("home", "", "")} data-one-column={OneColumn}>
        <section className={ClassNames("home", "content")}>
          {Projects.map((p) => (
            <HomeItem key={p.UID} OneColumnLayout={OneColumn} {...p} />
          ))}
        </section>
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/Components/Home/Home.tsx